
import {defineComponent} from 'vue';
import {GlassIconType, GLASS_ICON_TYPES} from './types';

export default defineComponent({
  name: 'oxd-glass-button',

  props: {
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      validator: function(value: GlassIconType) {
        return GLASS_ICON_TYPES.indexOf(value) !== -1;
      },
    },
  },

  computed: {
    btnClasses(): object {
      return {
        'oxd-glass-button': true,
        [`oxd-glass-button--disabled`]: this.disabled,
      };
    },
    iconClasses(): object {
      return {
        'oxd-glass-button-icon': true,
        'oxd-glass-button-icon--disabled': this.disabled,
        [`oxd-glass-button-icon--${this.icon}`]: this.icon,
      };
    },
  },
});
